/**
 * Extract content inside body from whole html document
 * @param fullHtml
 */
export default function (fullHtml) {
      let html = fullHtml.replace(/<body(.*)>/, '<body>');
      let start = html.indexOf('<body>') + 6;
      let end = html.indexOf('</body>');
      html = html.substring(start, end).trim();
      return html;
}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Mjml/MjmlTemplateExtractor.js